import React from "react";
import EngineerDashboard from "../../views/EngineerDashboard";

const EngineerDashboardPage = () => <EngineerDashboard />;

export default EngineerDashboardPage;
